import { useCollection } from "@/hooks/useCollection";
import type { HistoryEntry } from "@/lib/types";

export default function History() {
  const { items } = useCollection<HistoryEntry>("history");

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <span className="inline-block text-sm font-semibold text-primary-600">
              Notre histoire
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Une aventure née de la solidarité
            </h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              Depuis 2015, Humanity59 grandit grâce à l'engagement de tous
              et à la générosité de donateurs. Retour sur les grandes étapes qui
              ont façonné notre association.
            </p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              Ce qui n'était qu'une initiative de quartier est devenu un acteur
              incontournable de la solidarité, présent en Afrique et en Asie au
              service des plus démunis.
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-5 top-2 bottom-2 w-px bg-background-300"></div>
            <div className="space-y-10">
              {items.map((item, index) => (
                <div key={item.year || index} className="relative pl-14">
                  <span className="absolute left-0 top-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm font-bold">
                    {item.year}
                  </span>
                  <div className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6">
                    <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}